"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationStatusMapping = void 0;

var IntegrationStatusMapping =
/** @class */
function () {
  function IntegrationStatusMapping() {}

  IntegrationStatusMapping.prototype.StatusIdType = function () {
    return [{
      slug: 'assigned',
      name: 'Assigned',
      description: null,
      isAssigned: true,
      isPurchased: false,
      isConfirmedByRSVP: false,
      isDeclinedByRSVP: false,
      isLeftBehind: false,
      isNotYetPurchased: false,
      isRegistered: false,
      isUnconfirmed: false,
      isRecycled: false,
      isNotYetRegistered: false,
      isWaitlisted: false,
      isAffirmativeResponse: true,
      isUsed: true,
      checkedIn: false
    }, {
      slug: 'purchased',
      name: 'Purchased',
      description: null,
      isAssigned: false,
      isPurchased: true,
      isConfirmedByRSVP: false,
      isDeclinedByRSVP: false,
      isLeftBehind: false,
      isNotYetPurchased: false,
      isRegistered: false,
      isUnconfirmed: false,
      isRecycled: false,
      isNotYetRegistered: false,
      isWaitlisted: false,
      isAffirmativeResponse: true,
      isUsed: true,
      checkedIn: false
    }, {
      slug: 'confirmed-by-rsvp',
      name: 'Confirmed By RSVP',
      description: null,
      isAssigned: false,
      isPurchased: false,
      isConfirmedByRSVP: true,
      isDeclinedByRSVP: false,
      isLeftBehind: false,
      isNotYetPurchased: false,
      isRegistered: false,
      isUnconfirmed: false,
      isRecycled: false,
      isNotYetRegistered: false,
      isWaitlisted: false,
      isAffirmativeResponse: true,
      isUsed: true,
      checkedIn: false
    }, {
      slug: 'declined-by-rsvp',
      name: 'Declined By RSVP',
      description: null,
      isAssigned: false,
      isPurchased: false,
      isConfirmedByRSVP: false,
      isDeclinedByRSVP: true,
      isLeftBehind: false,
      isNotYetPurchased: false,
      isRegistered: false,
      isUnconfirmed: false,
      isRecycled: false,
      isNotYetRegistered: false,
      isWaitlisted: false,
      isAffirmativeResponse: false,
      isUsed: false,
      checkedIn: false
    }, {
      slug: 'left-behind',
      name: 'Left Behind',
      description: null,
      isAssigned: false,
      isPurchased: false,
      isConfirmedByRSVP: false,
      isDeclinedByRSVP: false,
      isLeftBehind: true,
      isNotYetPurchased: false,
      isRegistered: false,
      isUnconfirmed: false,
      isRecycled: false,
      isNotYetRegistered: false,
      isWaitlisted: false,
      isAffirmativeResponse: true,
      isUsed: true,
      checkedIn: false
    }, {
      slug: 'not-yet-purchased',
      name: 'Not Yet Purchased',
      description: null,
      isAssigned: false,
      isPurchased: false,
      isConfirmedByRSVP: false,
      isDeclinedByRSVP: false,
      isLeftBehind: false,
      isNotYetPurchased: true,
      isRegistered: false,
      isUnconfirmed: false,
      isRecycled: false,
      isNotYetRegistered: false,
      isWaitlisted: false,
      isAffirmativeResponse: false,
      isUsed: true,
      checkedIn: false
    }, {
      slug: 'registered',
      name: 'Registered',
      description: null,
      isAssigned: false,
      isPurchased: false,
      isConfirmedByRSVP: false,
      isDeclinedByRSVP: false,
      isLeftBehind: false,
      isNotYetPurchased: false,
      isRegistered: true,
      isUnconfirmed: false,
      isRecycled: false,
      isNotYetRegistered: false,
      isWaitlisted: false,
      isAffirmativeResponse: true,
      isUsed: true,
      checkedIn: false
    }, {
      slug: 'unconfirmed',
      name: 'Unconfirmed',
      description: null,
      isAssigned: false,
      isPurchased: false,
      isConfirmedByRSVP: false,
      isDeclinedByRSVP: false,
      isLeftBehind: false,
      isNotYetPurchased: false,
      isRegistered: false,
      isUnconfirmed: true,
      isRecycled: false,
      isNotYetRegistered: false,
      isWaitlisted: false,
      isAffirmativeResponse: false,
      isUsed: true,
      checkedIn: false
    }, {
      slug: 'recycled',
      name: 'Recycled',
      description: null,
      isAssigned: false,
      isPurchased: false,
      isConfirmedByRSVP: false,
      isDeclinedByRSVP: false,
      isLeftBehind: false,
      isNotYetPurchased: false,
      isRegistered: false,
      isUnconfirmed: false,
      isRecycled: true,
      isNotYetRegistered: false,
      isWaitlisted: false,
      isAffirmativeResponse: false,
      isUsed: false,
      checkedIn: false
    }, {
      slug: 'not-yet-registered',
      name: 'Not Yet Registered',
      description: null,
      isAssigned: false,
      isPurchased: false,
      isConfirmedByRSVP: false,
      isDeclinedByRSVP: false,
      isLeftBehind: false,
      isNotYetPurchased: false,
      isRegistered: false,
      isUnconfirmed: false,
      isRecycled: false,
      isNotYetRegistered: true,
      isWaitlisted: false,
      isAffirmativeResponse: false,
      isUsed: true,
      checkedIn: false
    }, {
      slug: 'waitlisted',
      name: 'Waitlisted',
      description: null,
      isAssigned: false,
      isPurchased: false,
      isConfirmedByRSVP: false,
      isDeclinedByRSVP: false,
      isLeftBehind: false,
      isNotYetPurchased: false,
      isRegistered: false,
      isUnconfirmed: false,
      isRecycled: false,
      isNotYetRegistered: false,
      isWaitlisted: true,
      isAffirmativeResponse: false,
      isUsed: false,
      checkedIn: false
    }, {
      slug: 'checked-in',
      name: 'Checked In',
      description: null,
      isAssigned: false,
      isPurchased: false,
      isConfirmedByRSVP: false,
      isDeclinedByRSVP: false,
      isLeftBehind: false,
      isNotYetPurchased: false,
      isRegistered: false,
      isUnconfirmed: false,
      isRecycled: false,
      isNotYetRegistered: false,
      isWaitlisted: false,
      isAffirmativeResponse: false,
      isUsed: true,
      checkedIn: true
    }];
  };

  IntegrationStatusMapping.prototype.StatusMappingType = function () {
    return [{
      slug: 'salesforce-campaign-member',
      name: 'Salesforce Campaign Member Status Mapping',
      description: 'Maps the Event Farm statuses to Salesforce campaign member statuses.',
      isSalesforceCampaignMember: true
    }];
  };

  return IntegrationStatusMapping;
}();

exports.IntegrationStatusMapping = IntegrationStatusMapping;